<div class="mb-5">
    <a routerLink="/sistemerp/clienti/lista" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">
        <i class="icofont-arrow-left"></i> Inapoi la clienti
    </a>
</div>
<div class="card card-custom" *ngIf="clientData">
    <div class="card-header align-items-center">
        <div class="card-title">
            <h3 class="card-label">Vizualizare client - {{clientData.companyName}}</h3>
        </div>
        <div class="action-btn">
            <a routerLink="/sistemerp/clienti/editare/{{clientData.id}}" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">
                <i class="icofont-edit"></i> Editare client
            </a>
        </div>
    </div>
    <div class="card-body">
        <div class="row pt-10 pb-10">
            <div class="col-lg-3">
                <div class="logo-wrapper">
                    <img src='{{clientLogo}}' alt="profile image" class="companyLogoImage"/>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="company-main-info">
                    <h2>{{clientData.companyName}}</h2>
                    <div class="top-rating mb-5">
                        <ngb-rating [(rate)]="clientData.rating" [max]="5" class="no-outline" readonly="true">
                            <ng-template let-fill="fill">
                                <span class="star" [class.filled]="fill === 100">&#9733;</span>
                            </ng-template>
                        </ngb-rating>
                        <span class="ratings-number">
                            <span>({{clientData.numberOfReviews}}</span>
                            <span *ngIf="clientData.numberOfReviews === 1"> recenzie)</span>
                            <span *ngIf="clientData.numberOfReviews != 1"> recenzii)</span>
                        </span>


                    </div>
                    <p class="address-info"><i class="fas fa-map-marker-alt mr-3"></i>{{clientData.companyAddress}}</p>
                </div>
                <!--                <div *ngIf="isAuthor">-->
                <!--                    <div class="company-edit-profile row">-->
                <!--                        <a routerLink="/editare-companie/{{companyData.id}}" class="round-button orange-background mr-5">Editeaza compania</a>-->
                <!--                        <a routerLink="/adauga-job" class="round-button green-background">Publica un job</a>-->
                <!--                    </div>-->
                <!--                </div>-->


            </div>
            <div class="col-lg-3">
                <div class="social-wrapper">
                    <a href="{{companyFacebook}}" target="_blank" *ngIf="companyFacebook" class="btn btn-light font-weight-bold py-2 mb-2"><i
                            class="icofont-facebook"></i>Facebook</a>
                    <a href="{{companyInstagram}}" target="_blank" *ngIf="companyInstagram"  class="btn btn-light font-weight-bold py-2 mb-2"><i
                            class="icofont-instagram"></i>Instagram</a>
                    <a href="{{companyLinkedIn}}" target="_blank" *ngIf="companyLinkedIn" class="btn btn-light font-weight-bold py-2 mb-2"><i
                            class="icofont-linkedin"></i>LinkedIn</a>
                    <a href="{{companyTikTok}}" target="_blank" *ngIf="companyTikTok" class="btn btn-light font-weight-bold py-2 mb-2"><i class="fab fa-tiktok" ></i>TikTok</a>
                    <a href="{{companyYouTube}}" target="_blank" *ngIf="companyYouTube" class="btn btn-light font-weight-bold py-2 mb-2"><i class="icofont-youtube"></i>YouTube</a>
                    <a href="{{companyWebsite}}" target="_blank" *ngIf="companyWebsite" class="btn btn-light font-weight-bold py-2 mb-2"><i class="icofont-web"></i>Website</a>
                </div>
            </div>
        </div>
        <hr>
        <div class="row pt-10">
            <div class="col-md-8">
                <h3 class="mb-5">Despre companie</h3>
                <div class="company-description" [innerHtml]=clientData.companyDescription></div>
                <div class="company-info pt-10">
                    <h3 class="mb-5">Alte informatii</h3>
                    <div class="row">
                        <div class="col-md-6">
                            <p><i class="icofont-barcode"></i><span class="text-semi-bold">Cod fiscal: </span> {{clientData.fiscalCode}}</p>
                            <p><i class="icofont-location-pin"></i><span class="text-semi-bold">Locatie: </span> {{clientData.city}}, {{clientData.country}}</p>
                            <p><i class="icofont-briefcase-2"></i><span class="text-semi-bold">Platitor de TVA: </span>
                                <span *ngIf="clientData.vatCode; else falseVat">DA</span>
                                <ng-template #falseVat>NU</ng-template>
                            </p>
                            <p><i class="icofont-files-stack"></i><span class="text-semi-bold">Domeniu: </span> {{clientData.activitySector}} </p>
                            <p><i class="icofont-files-stack"></i><span class="text-semi-bold">Subdomeniu: </span> {{clientData.activitySubSector}}</p>
                            <p><i class="icofont-building"></i><span class="text-semi-bold">Tip companie: </span>
                                <span>{{clientData.companyType | enumTransform}}</span>
                            </p>
                            <p><i class="icofont-people"></i><span class="text-semi-bold">Nivel companie (nr. angajati): </span>
<!--                                <span>{{clientData.companyEmployeesLevel | enumTransform}}</span>-->
                                <span *ngIf="clientData.companyEmployeesLevel==='micro' ">Micro (1-9 angajati)</span>
                                <span *ngIf="clientData.companyEmployeesLevel==='small' ">Mica (10-49 angajati)</span>
                                <span *ngIf="clientData.companyEmployeesLevel==='medium' ">Medie (50-249 angajati)</span>
                                <span *ngIf="clientData.companyEmployeesLevel==='big' ">Mare (peste 250 angajati)</span>
                            </p>
                            <p><i class="icofont-coins"></i><span class="text-semi-bold">Nivel companie (cifra de afaceri): </span>
<!--                                <span>{{clientData.companyRevenue | enumTransform}}</span>-->
                                <span *ngIf="clientData.companyRevenue==='micro'">Micro(sub 2 mil. euro)</span>
                                <span *ngIf="clientData.companyRevenue==='small'">Mica(2-10 mil. euro)</span>
                                <span *ngIf="clientData.companyRevenue==='medium'">Medie(11-49 mil. euro)</span>
                                <span *ngIf="clientData.companyRevenue==='big'">Mare(peste 50 mil. euro)</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">Planuri de angajare - Anul in curs: </span>
                                <span>{{clientData.employmentThisYear}}</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">Planuri de angajare - Anul urmator: </span>
                                <span>{{clientData.employmentNextYear}}</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">Planuri de angajare - Urgente: </span>
                                <span>{{clientData.employmentEmergencies}}</span>
                            </p>
                        </div>
                        <div class="col-md-6">
                            <p><i class="icofont-user-suited"></i><span class="text-semi-bold">Administrator</span></p>
                            <div class="admin-info">
                                <p> <span>{{clientData.administratorFirstName}}</span></p>
                                <p><span>{{clientData.administratorLastName}}</span></p>
                                <p><span class="text-semi-bold">Telefon: </span>
                                    <span>{{clientData.administratorTelephone}}</span>
                                </p>
                                <p><span class="text-semi-bold">Email: </span>
                                    <span>{{clientData.administratorEmail}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-md-4">
                <h3 class="mb-5">Joburi active</h3>
                <p *ngIf="jobs.length === 0">Nu exista joburi active.</p>


                <div class=" card company-jobs mb-5" *ngFor="let job of jobs  | slice:0:3">
                    <div>
                        <a routerLink="/job/{{job.id}}">
                            <img class="job-logo img-fluid" src="{{job.photoPath}}" alt="Job Logo">
                        </a>
                    </div>
                    <div class="card-body">
                        <div>
                            <a routerLink="/job/{{job.id}}">
                                <h3>{{job.jobTitle}}</h3>
                            </a>
                        </div>
                        <div class="job-location">
                            <span><i class="icofont-location-pin mr-2"></i>{{job.country}} - {{job.city}}</span>
                        </div>
                        <span><i class="icofont-files-stack mr-2"></i>{{job.workType}}</span>
                        <span class="post-date d-block"><i class="icofont-clock-time mr-2"></i> {{job.jobPostingDate | date:"dd-MM-yyyy"}}</span>
                    </div>
                </div>

                <div class="jobs-buttons-wrapper">
                    <a routerLink="/joburi/{{clientData.id}}" class="round-button yellow-background" *ngIf="jobs.length > 0">Vezi toate joburile</a>
                </div>
            </div>
        </div>
    </div>
</div>
